import type { DeepRequired } from '../fixtures.types'

const miDocument: DeepRequired<MiDocumentSummaryResponse> = {
  __typename: 'MIDocumentSummaryResponse',
  filters: {
    __typename: 'MIDocumentFilters',
    page_size: 100,
    bookmark: 0,
    case_ids: [],
    categories: [],
    client_ids: [],
    include_archived: false,
    order_by: null,
    sort_order: null,
    types: [],
  },
  next_page: null,
  documents: [],
}

export default miDocument
